module.exports = __webpack_public_path__ + "img/logo.98925189.png";